import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ children }) => (
  <div className="map__label-wrapper">
    {children}
  </div>
);

Label.propTypes = {
  children: PropTypes.array,
};

export default Label;
